export const TOGGLE = {
  MAP: 'map',
  LIST: 'list'
};

export const VIEW_MODE = {
  TABLE: 'table',
  LIST: 'list'
};

export const VIEW = {
  DEPT_LIST: 0,
  MACHINE_LIST: 1,
  REPORT_LIST: 2,
  GRAPH_LIST: 4,
  XINDICATE_ALL: 3,
  OTHER: 999,
  DEPARTMENT: 'DEPARTMENT',
  MACHINE : 'MACHINE',
  REPORT: 'REPORT',
  PERFORMANCE_GRAPH: 'PERFORMANCE_GRAPH',
  PERFORMANCE_TABLE:'PERFORMANCE_TABLE'
};

export const TYPE = {
  LAMINATING: 'LAMINATING',
  SLITTING: 'SLITTING',
  PRINTING: 'PRINTING',
  EXTRUSION: 'EXTRUSION',
  BAGMAKING: 'BAGMAKING',

};

export const REPORT_TYPE = {
  DAILY: 'DAILY',
  LAST_WEEK: 'LAST_WEEK',
  MONTHLY: 'MONTHLY',
  ANNUAL: 'ANNUAL',
  CUSTOM: 'CUSTOM',

};

export const REPORT_NAMES = {
  PERFORMANCE: 'performance',
  ACHIEVEMENT: 'achievement',
  OEE: 'oee',
  DOWNTIME: 'downtime',
  AVERAGE_ORDER_SIZE: 'averageOrderSize',
  WASTAGE: 'wastage',
  UTILIZATION: 'utilization',

  PERFORMANCE_BC: 'Performance',
  ACHIEVEMENT_BC: 'Achievement',
  OEE_BC: 'OEE',
  DOWNTIME_BC: 'Down Time',
  AVERAGE_ORDER_SIZE_BC: 'Average Order Size',
  WASTAGE_BC: 'Wastage',
  UTILIZATION_BC: 'Utilization',
};


export const IRRIGATION_STATUS = {
  ON: 'ON',
  ON_REQUESTED: 'ON_REQUESTED',
  OFF: 'OFF',
  ERROR: 'ERROR',
  PENDING: 'PENDING',
  OFF_REQUESTED: 'OFF_REQUESTED'
};

export const DAYS = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY'
};

export const IRRIGATION_MODE = {
  MANUAL: 'MANUAL',
  SCHEDULE: 'SCHEDULE',
  DAILY: 'DAILY',
  AUTOMATION: 'AUTOMATION',
};
export const ACTUATOR_TYPE = {
  DISPENSER: 'DISPENSER',
  MOTOR: 'MOTOR',
  TANK: 'TANK',
  BRANCH: 'BRANCH',
};
export const CASH_FLOW_TYPE = {
  INCOME: 'INCOME',
  EXPENSE: 'EXPENSE',
};
export const UNITS = {
  Kg: 'Kg',
  g: 'g',
  L: 'L',
  None :'None'
};
export const CASH_STATUS = {
  CASH_PENDING: 'Pending',
  PAID: 'Paid',
  CASH_NOT_PAID: 'NotPaid',
  ADVANCE_PAID: 'AdvancePaid',
};
export const CASH_STATUS_INCOME = {
  CASH_RECEIVED: 'Received',
  CASH_RECEIVABLE: 'Receivable'
};

export const PROGRAM_CATEGORY = {
  CATEGORY_EDUCATION: 'EDUCATION',
  CATEGORY_AGRICULTURE: 'AGRICULTURE',
  CATEGORY_HEALTH: 'HEALTH'
};

export const FIELDS_TYPE = {
  TYPE_TEXT: 'TEXT',
  TYPE_INT: 'INT',
  TYPE_ENUM: 'ENUM',
  TYPE_DATE: 'DATE'
};

export const DELETE_REASON = {
  CATEGORY_DEATH: 'DEATH',
  CATEGORY_INCORRECT_DATA: 'INCORRECT DATA',
  CATEGORY_DUPLICATE_DATA: 'DUPLICATE DATA',
  CATEGORY_FRAUD: 'FRAUD',
  CATEGORY_MOVED: 'MOVED'
};

export const GENDER = {
  GENDER_MALE: 'MALE',
  GENDER_FEMALE: 'FEMALE'
};

export const EXPENSE_CATEGORY = {
  LABOUR_CHARGE: 'LABOUR_CHARGE',
  FIXED_ASSET: 'FIXED_ASSET',
  REPAIR_MAINTENANCE: 'REPAIR_MAINTENANCE',
  CURRENT_ASSET: 'CURRENT_ASSET',
  OTHER: 'OTHER'
};

export const LABOUR_CHARGE_TYPE = {
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
};
export const VALVES_TYPE = {
  ALL: 'ALL',
  ASSIGNED: 'ASSIGNED',
  UN_ASSIGNED: 'UN_ASSIGNED',
};

export const YieldFilter = {
  ALL: 'ALL',
  AVAILABLE: 'AVAILABLE',
};

export const MODULE = {
  SMART_FARM: 'SMART_FARM',
  CASH_FLOW: 'CASH_FLOW',
  DAILY_UPDATE: 'DAILY_UPDATE',
  SETTINGS: 'SETTINGS',
  REPORT: 'REPORT',
  XINDICATE: 'XINDICATE',
};

export const CASH_FLOW_REPORT_TYPE = {
  CASH_FLOW_REPORT_TYPE: 'CASH_FLOW_REPORT_TYPE',
  MONTHLY_INCOME_REPORT: 'MONTHLY_INCOME_REPORT',
  MONTHLY_EXPENSE_REPORT: 'MONTHLY_EXPENSE_REPORT',
  WASTAGE: 'WASTAGE',
  YIELD: 'YIELD'
};

